import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-dropdown-select';
import services from '../../services';
import './User.css';
import { MultiSelect } from 'react-multi-select-component';
import { toast } from 'react-toastify';
import DeletePopup from '../DeletePopup';

const UserAssignBoard = () => {
    const { state } = useLocation();
    const [allPermission, setAllPermission] = useState([]);
    const [boardColumn, setBoardColumn] = useState([]);
    const [selectedPerIds, setSelectedPerIds] = useState([]);
    const [selectedColumnIds, setSelectedColumnIds] = useState([]);
    const [selectedBoards, setSelectedBoards] = useState([]);
    const [boardName, setBoardName] = useState([]);
    const navigate = useNavigate();

    const [allASSIGNMENT, setAllASSIGNMENT] = useState([]);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const handleSelect = (selected) => {
        setSelectedBoards(selected);
        if (selected && selected.length > 0) {
            getBoardColumn(selected[0].value);
        } else {
            setBoardColumn([]);
        }
    };

    const assignedBoardIds = allASSIGNMENT?.map((a) => a.Board?.value);
    const availableBoards = boardName.filter((b) => !assignedBoardIds.includes(b.value));

    const handleEditBoard = async (id, item) => {
        const data = {
            boardId: item.Board?.value,
            userId: state.id,
            boardListId: item.boardListId?.map((col) => col), // or col.value if your API expects just IDs
            permissions: item.permissions?.map((per) => per), // or per.value if your API expects just IDs
        };
        try {
            const response = await services.userassignboard.UPDATE_UserAssignBoard(id, data);
            if (response.status === 200) {
                toast.success('Assignment updated successfully');
                GET_ALL_ASSIGNMENT();
            }
        } catch (e) {
            console.error(e);
            toast.error('Failed to update assignment');
        }
    };

    const getAllBoard = async () => {
        try {
            const { data } = await services.board.GETALLBOARD();
            const filterData =
                (data && data.length > 0 && data.map(({ boardName, id }) => ({ label: boardName, value: id }))) || [];

            setBoardName(filterData);
            GET_ALL_ASSIGNMENT(filterData);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getAllBoard();
        GET_ALL_PERMISSION();
    }, []);

    const GET_ALL_PERMISSION = async () => {
        try {
            const response = await services.permission.GET_ALL_PERMISSION();
            const data =
                (response &&
                    response.length > 0 &&
                    response.map((item) => ({
                        ...item,
                        label: item.name,
                        permission_details: item.details,
                        value: item.id,
                    }))) ||
                [];
            setAllPermission(data);
        } catch (e) {
            console.error(e);
        }
    };

    const getBoardColumn = async (id) => {
        try {
            const response = await services.board.SELECTED_BOARD(id);
            const data = response?.data?.map((item) => ({
                value: item?.id,
                label: item?.coloum,
            }));
            setBoardColumn(data);
        } catch (e) {
            console.error(e);
        }
    };

    const handleSubmit = async (item) => {
        //         if(item){
        //             try{
        // const response = await services.userassignboard.UPDATE_UserAssignBoard()
        //             }catch(e){
        //                 console.error(e)
        //             }
        //         }
        const data = {
            boardId: selectedBoards[0]?.value,
            userId: state.id,
            boardListId: selectedColumnIds.map((item) => item),
            permissions: selectedPerIds.map((item) => item),
        };
        try {
            const response = await services.userassignboard.CREATE_UserAssignBoard(data);
            if (response.status === 201) {
                toast.success('Board assigned successfully');
                setSelectedBoards([]);
                setSelectedColumnIds([]);
                setSelectedPerIds([]);
                GET_ALL_ASSIGNMENT();
            }
        } catch (e) {
            console.error(e);
        }
    };

    const GET_ALL_ASSIGNMENT = async (filterData) => {
        try {
            const response = await services.userassignboard.GET_UserAssignBoard_ID(state.id);
            
            const dataMap = response?.data?.data?.map((item, index) => ({
                ...item,
                boardListId: typeof item?.boardListId === 'string' ? JSON.parse(item?.boardListId) : item?.boardListId,
                permissions: typeof item?.permissions === 'string' ? JSON.parse(item?.permissions) : item?.permissions,
                BoardLists: Array.isArray(item?.Board?.BoardLists)
                    ? item.Board.BoardLists.map((listItem) => ({
                          label: listItem?.coloum,
                          value: listItem?.id,
                      }))
                    : [],
                Board: item?.Board
                    ? {
                          label: item.Board.boardName,
                          value: item.Board.id,
                      }
                    : { label: '', value: '' },
            }));
            setAllASSIGNMENT(dataMap || []);
        } catch (e) {
            console.error(e);
        }
    };

    const handleEditCol = (index, selectedOptions) => {
        // Create a copy of allASSIGNMENT
        const updatedAssignments = [...allASSIGNMENT];
        // Update the boardListId for the specific assignment
        updatedAssignments[index] = {
            ...updatedAssignments[index],
            boardListId: selectedOptions,
        };
        setAllASSIGNMENT(updatedAssignments);
    };

    const handleEditPer = (index, select) => {
        const data = [...allASSIGNMENT];
    };

    const handleDelete = async (id) => {
        setDeleteId(id);
        setShowDeletePopup(true);
    };

    const confirmDelete = async () => {
        try {
            const response = await services.userassignboard.DELETE_UserAssignBoard(deleteId);
            if (response.status === 200) {
                toast.success('Assignment deleted successfully');
                getAllBoard();
            }
        } catch (e) {
            toast.error('Failed to delete assignment');
            console.error(e);
        } finally {
            setShowDeletePopup(false);
            setDeleteId(null);
        }
    };

    const cancelDelete = () => {
        setShowDeletePopup(false);
        setDeleteId(null);
    };

    const handleEditSelect = async (selected, index) => {
        if (!selected || selected.length === 0) return;

        const selectedBoard = selected[0];
        // Fetch columns for the selected board
        try {
            const response = await services.board.SELECTED_BOARD(selectedBoard.value);
            const columns = response?.data?.map((item) => ({
                value: item?.id,
                label: item?.coloum,
            }));

            // Update the assignment at the given index
            const updatedAssignments = [...allASSIGNMENT];
            updatedAssignments[index] = {
                ...updatedAssignments[index],
                Board: selectedBoard,
                BoardLists: columns,
                boardListId: [], // Reset selected columns when board changes
            };
            setAllASSIGNMENT(updatedAssignments);
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <div className="relative user-assign-board-container">
            <h1 className="header">Assign Boards and Columns</h1>
            <div className="absolute top-[6vw] left-[2vw]" onClick={() => navigate(-1)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H19v-2z" />
                </svg>
            </div>

            {allASSIGNMENT?.map((item, index) => (
                <div key={index}>
                    <div className="board-container">
                        <div className="form-row">
                            <div className="form-item">
                                <div className="label">Board</div>
                                <div style={{ width: '65%' }}>
                                    <Select
                                        options={boardName}
                                        onChange={(selected) => handleEditSelect(selected, index)}
                                        values={[item?.Board]}
                                    />
                                </div>
                            </div>
                            <div className="form-item">
                                <div className="label">Column</div>
                                <div className="drop-header">
                                    <MultiSelect
                                        options={item?.BoardLists}
                                        value={item?.boardListId}
                                        // onChange={(selectedOptions) => setSelectedColumnIds(selectedOptions)}
                                        onChange={(selectedOptions) => handleEditCol(index, selectedOptions)}
                                        labelledBy="Select Column"
                                    />
                                </div>
                            </div>

                            {/* <div className="form-item">
                                <div className="label">Permissions</div>
                                <div className="drop-header">
                                    <MultiSelect
                                        options={allPermission}
                                        value={item?.permissions}
                                        // onChange={(selectedOptions) => setSelectedPerIds(selectedOptions)}
                                        onChange={(selectedOptions) => handleEditPer(index, selectedOptions)}
                                        labelledBy="Select Permissions"
                                    />
                                </div>
                            </div> */}

                            <div className="save-item gap-2">
                                <button className="btn btn-primary" onClick={() => handleEditBoard(item.id, item)}>
                                    Update
                                </button>
                                <button className="btn btn-outline-primary" onClick={() => handleDelete(item.id)}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            <div
                className="label p-2 ml-[6vw]"
                style={{ display: 'flex', justifyContent: 'start', alignItems: 'start' }}
            >
                New Assignment
            </div>

            <div>
                <div className="board-container">
                    <div className="form-row">
                        <div className="form-item">
                            <div className="label">Board</div>
                            <div style={{ width: '65%' }}>
                                <Select options={availableBoards} onChange={handleSelect} values={selectedBoards} />
                            </div>
                        </div>
                        <div className="form-item">
                            <div className="label">Column</div>
                            <div className="drop-header">
                                <MultiSelect
                                    options={boardColumn}
                                    value={selectedColumnIds}
                                    onChange={(selectedOptions) => setSelectedColumnIds(selectedOptions)}
                                    labelledBy="Select Column"
                                />
                            </div>
                        </div>

                        {/* <div className="form-item">
                            <div className="label">Permissions</div>
                            <div className="drop-header">
                                <MultiSelect
                                    options={allPermission}
                                    value={selectedPerIds}
                                    onChange={(selectedOptions) => setSelectedPerIds(selectedOptions)}
                                    labelledBy="Select Permissions"
                                />
                            </div>
                        </div> */}

                        <div className="save-item">
                            <button className="btn btn-primary" onClick={handleSubmit}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {showDeletePopup && (
                <DeletePopup
                    open={showDeletePopup}
                    title="Are you sure you want to delete this assignment?"
                    // description="You will no longer be able to view it."
                    onConfirm={confirmDelete}
                    onCancel={cancelDelete}
                    confirmLabel="YES, I'M SURE"
                    cancelLabel="NO"
                />
            )}
        </div>
    );
};

export default UserAssignBoard;
